import React, { useContext } from "react";


import Footer from "./footer";
import { useState } from "react";
import { Link } from 'react-router-dom';
import { PartenerSheepDeedService } from "../services/parternshipservice";

import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import { ServicesContext } from "../services/ServicesContext";



import Testimonial from "./Testimonial"


import PricingPlan2 from "./gstpricingplan";


function GSTreturnfiling() {

   const [activeQuestion, setActiveQuestion] = useState(null);

   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };


   const [selectedOption, setSelectedOption] = useState("option1");
   


   const handleChange = (event) => {
      setSelectedOption(event.target.value);
   };
   const [activeTab, setActiveTab] = useState(1); // Default active tab is the first one

   const showContent = (tabId) => {
      setActiveTab(tabId);
   };




   const tenures1 = [
      {
         duration: "yearly",
         value: "1 Year",
         label: "1 Year",
         price: "₹7251.00",
         yearlyPrice: "₹19336.00",
         savings: "Save 50% + 25%",
      },
      {
         duration: "Monthly",
         value: "1 Month",
         label: "1 Month",
         price: "₹751.00",
         yearlyPrice: "₹1502.00",
         savings: "Save 50% + 25%",
      },
      {
         duration: "Quarterly",
         value: "3 Months",
         label: "3 Months",
         price: "₹2351.00",
         yearlyPrice: "₹4702.00",
         savings: "Save 50%",
      },
      {
         duration: "Half-yearly",
         value: "6 Months",
         label: "6 Months",
         price: "₹4051.00",
         yearlyPrice: "₹9532.00",
         savings: "Save 50% + 15%",
      },
      {
         duration: "yearly",
         value: "2 Years",
         label: "2 Years",
         price: "₹14502.00",
         yearlyPrice: "₹38672.00",
         savings: "Save 50% + 25%",
      },
      // Add other tenures
   ];

   const requirements1 = [
      
      "GSTR - 1 & GSTR - 3B (or)",
      "Sales & Purchase Data in Excel (or)",
      " Sales and Purchase Invoice",
   ];

   const inclusions1 = [

       'E-way bill facility (If required)',
      "Documents sharing",
     
      "Password sharing",
      "Round the clock support",
      "Time to time updates & notifications",
      'Time to time advice and support',
      'Number of Monthly Invoices/Bills Cover up to ',
      
   ];


   // 

   const tenures = [
      {
         duration: "yearly",

         label: "1 Year",
         price: "8251.00",
         yearlyPrice: "22003.00",
         savings: "Save 50% + 25%",
      },
      {
         duration: "Monthly",

         label: "1 Month",
         price: "951.00",
         yearlyPrice: "1902.00",
         savings: "Save 50%",
      },
      {
         duration: "Quarterly",

         label: "3 Months",
         price: "2651.00",
         yearlyPrice: "5302.00",
         savings: "Save 50%",
      },
      {
         duration: "Half-yearly",

         label: "6 Months",
         price: "4451.00",
         yearlyPrice: "10473.00",
         savings: "Save 50% + 15%",
      },
      {
         duration: "yearly",

         label: "2 Years",
         price: "16502.00",
         yearlyPrice: "44005.00",
         savings: "Save 50% + 25%",
      },
   ];

   const requirements = [
      
      "GSTR - 1 & GSTR - 3B (or)",
      "Sales & Purchase Data in Excel (or)",
      " Sales and Purchase Invoice",
   ];

   const inclusions = [

       'E-way bill facility (If required)',
      "Documents sharing",
     
      "Password sharing",
      "Round the clock support",
      "Time to time updates & notifications",
      'Time to time advice and support',
      'Number of Monthly Invoices/Bills Cover up to ',
      
   ];


   const tenures2 = [
      { label: "1 Year", price: "8751.00", yearlyPrice: "23336.00", savings: "Save 50% + 25%", value: "1 Year", duration: "yearly", },
      { label: "1 Month", price: "1151.00", yearlyPrice: "2302.00", savings: "Save 50%", value: "1 Month", duration: "Monthly", },
      { label: "3 Months", price: "2851.00", yearlyPrice: "5702.00", savings: "Save 50%", value: "3 Months", duration: "Quarterly", },
      { label: "6 Months", price: "4851.00", yearlyPrice: "11414.00", savings: "Save 50% + 15%", value: "6 Months", duration: "Half-yearly", },
      { label: "2 Years", price: "17502.00", yearlyPrice: "46672.00", savings: "Save 50% + 25%", value: "2 Years", duration: "yearly", },
   ];

   const requirements2 = [
      "Sales & Purchase Invoices",

   ];

   const inclusions2 = [
      "GSTR-2A Reconciliation mismatch report",
      "Data preparation on basis of Invoices",
      "Dashboard for managing services",

      "Documents sharing facility",
      "Download deliverables anytime",
      "Password sharing",
      "Round the clock support",
      "Time to time updates & notifications"
   ];


   const tenures3 = [
      {
         duration: "yearly",
         label: "1 Year",
         price: "9751.00",
         yearlyPrice: "26003.00",
         savings: "Save 50% + 25%",
         value: "4 Years"
      },
      {
         duration: "Monthly",
         label: "1 Month",
         price: "1251.00",
         yearlyPrice: "2502.00",
         savings: "Save 50%",
         value: "1 Year"
      },
      {
         duration: "Quarterly",
         label: "3 Months",
         price: "3051.00",
         yearlyPrice: "6102.00",
         savings: "Save 50%",
         value: "2 Years"
      },
      {
         duration: "Half-yearly",
         label: "6 Months",
         price: "5251.00",
         yearlyPrice: "12355.00",
         savings: "Save 50% + 15%",
         value: "3 Years"
      },
      {
         duration: "yearly",
         label: "2 Years",
         price: "19502.00",
         yearlyPrice: "52005.00",
         savings: "Save 50% + 25%",
         value: "5 Years"
      }
   ];

   const requirements3 = [
      
      "GSTR - 1 & GSTR - 3B (or)",
      "Sales & Purchase Data in Excel (or)",
      " Sales and Purchase Invoice",
   ];

   const inclusions3 = [

       'E-way bill facility (If required)',
      "Documents sharing",
     
      "Password sharing",
      "Round the clock support",
      "Time to time updates & notifications",
      'Time to time advice and support',
      'Number of Monthly Invoices/Bills Cover up to ',
      
   ];



   const tenures4 = [
      {
         duration: "yearly",
         label: "1 Year",
         price: "₹9251.00",
         yearlyPrice: "₹24669.00",
         savings: "Save 50% + 25%",
      },
      {
         value: "1 Year",
         duration: "Mothly",
         label: "1 Month",
         price: "₹1151.00",
         yearlyPrice: "₹2302.00",
         savings: "Save 50%",
      },
      {
         value: "2 Years",
         duration: "Qurterly",
         label: "3 Months",
         price: "₹2951.00",
         yearlyPrice: "₹5902.00",
         savings: "Save 50%",
      },
      {
         value: "3 Years",
         duration: "Half-Yearly",
         label: "6 Months",
         price: "₹5051.00",
         yearlyPrice: "₹11005.00",
         savings: "Save 50% + 15%",
      },
      {
         value: "5 Years",
         label: "2 Years",
         duration: "yearly",
         price: "₹18502.00",
         yearlyPrice: "₹49339.00",
         savings: "Save 50% + 25%",
      },
   ];


   const requirements4 = [
      
      "GSTR - 1 & GSTR - 3B (or)",
      "Sales & Purchase Data in Excel (or)",
      " Sales and Purchase Invoice",
   ];

   const inclusions4 = [

       'E-way bill facility (If required)',
      "Documents sharing",
     
      "Password sharing",
      "Round the clock support",
      "Time to time updates & notifications",
      'Time to time advice and support',
      'Number of Monthly Invoices/Bills Cover up to ',
      
   ];

   const tenures5 = [
      {
         value: "4 Years",
         duration: "yearly",
         label: "1 Year",
         price: "₹10251.00",
         yearlyPrice: "₹27336.00",
         savings: "Save 50% + 25%",
      },
      {
         value: "1 Year",
         duration: "Monthly",
         label: "1 Month",
         price: "₹1251.00",
         yearlyPrice: "₹2502.00",
         savings: "Save 50%",
      },
      {
         value: "2 Years",
         duration: "Qurterly",
         label: "3 Months",
         price: "₹3251.00",
         yearlyPrice: "₹6502.00",
         savings: "Save 50%",
      },
      {
         value: "3 Years",
         duration: "Half-yearly",
         label: "6 Months",
         price: "₹5551.00",
         yearlyPrice: "₹13061.00",
         savings: "Save 50% + 15%",
      },
      {
         value: "5 Years",
         duration: "yearly",
         label: "2 Years",
         price: "₹20502.00",
         yearlyPrice: "₹54672.00",
         savings: "Save 50% + 25%",
      },
   ];

   const requirements5 = [
      
      "GSTR - 1 & GSTR - 3B (or)",
      "Sales & Purchase Data in Excel (or)",
      " Sales and Purchase Invoice",
   ];

   const inclusions5 = [

       'E-way bill facility (If required)',
      "Documents sharing",
     
      "Password sharing",
      "Round the clock support",
      "Time to time updates & notifications",
      'Time to time advice and support',
      'Number of Monthly Invoices/Bills Cover up to ',
      
   ];

   const tenures6 = [
      {
         value: "4 Years",
         label: "1 Year",
         price: "₹11251.00",
         duration: "yearly",
         yearlyPrice: "₹30003.00",
         extra: "Nil",
         savings: "Save 50% + 25%",
      },
      {
         value: "1 Year",
         label: "1 Month",
         price: "₹1351.00",
         duration: "month",
         yearlyPrice: "₹2702.00",
         extra: "Nil",
         savings: "Save 50%",
      },
      {
         value: "2 Years",
         label: "3 Months",
         price: "₹3551.00",
         duration: "Quarterly",
         yearlyPrice: "₹7102.00",
         extra: "Nil",
         savings: "Save 50%",
      },
      {
         value: "3 Years",
         label: "6 Months",
         price: "₹6051.00",
         duration: "Half-yearly",
         yearlyPrice: "₹14230.00",
         extra: "Nil",
         savings: "Save 50% + 15%",
      },
      {
         value: "5 Years",
         label: "2 Years",
         price: "₹22502.00",
         duration: "yearly",
         yearlyPrice: "₹60005.00",
         extra: "Nil",
         savings: "Save 50% + 25%",
      },
   ];
   const requirements6 = ["Sales & Purchase Invoices"];
   const inclusions6 = [
      "GSTR-2A Reconciliation mismatch report",
      "Included data preparation (on basis of Invoices)",


      "Documents sharing facility",
      "Download deliverables any time",
      "Password sharing",
      "Round the clock support",
      "Time to time updates & notifications",
   ];

   const tenures7 = [
      {
         duration: "yearly",
         value: "4 Years",
         label: "1 Year",
         price: "₹12251.00",
         yearlyPrice: "₹32669.00",
         savings: "Save 50% + 25%",
      },
      {
         duration: "Monthly",
         value: "1 Year",
         label: "1 Month",
         price: "₹1551.00",
         yearlyPrice: "₹3102.00",
         savings: "Save 50%",
      },
      {
         duration: "Quarterly",
         value: "2 Years",
         label: "3 Months",
         price: "₹3951.00",
         yearlyPrice: "₹7902.00",
         savings: "Save 50%",
      },
      {
         duration: "Half-yearly",
         value: "3 Years",
         label: "6 Months",
         price: "₹6651.00",
         yearlyPrice: "₹15649.00",
         savings: "Save 50% + 15%",
      },
      {
         duration: "yearly",
         value: "5 Years",
         label: "2 Years",
         price: "₹24502.00",
         yearlyPrice: "₹65339.00",
         savings: "Save 50% + 25%",
      },
   ];
   const requirements7 = [
      
      "GSTR - 1 & GSTR - 3B (or)",
      "Sales & Purchase Data in Excel (or)",
      " Sales and Purchase Invoice",
   ];

   const inclusions7 = [

       'E-way bill facility (If required)',
      "Documents sharing",
     
      "Password sharing",
      "Round the clock support",
      "Time to time updates & notifications",
      'Time to time advice and support',
      'Number of Monthly Invoices/Bills Cover up to ',
      
   ];

   const tenures8 = [
      {
         duration: "yearly",
         value: "4 Years",
         label: "1 Year",
         price: "₹11251.00",
         yearlyPrice: "₹30003.00",
         savings: "Save 50% + 25%",
      },
      {
         duration: "Monthly",
         value: "1 Year",
         label: "1 Month",
         price: "₹1351.00",
         yearlyPrice: "₹2702.00",
         savings: "Save 50%",
      },
      {
         duration: "Quarterly",
         value: "2 Years",
         label: "3 Month",
         price: "₹3551.00",
         yearlyPrice: "₹7102.00",
         savings: "Save 50%",
      },
      {
         duration: "Half-yearly",
         value: "3 Years",
         label: "6 Month",
         price: "₹6051.00",
         yearlyPrice: "₹14230.00",
         savings: "Save 50% + 15%",
      },
      {
         duration: "yearly",
         value: "5 Years",
         label: "2 Year",
         price: "₹22502.00",
         yearlyPrice: "₹60005.00",
         savings: "Save 50% + 25%",
      },
   ];


   const requirements8 = [
      
      "GSTR - 1 & GSTR - 3B (or)",
      "Sales & Purchase Data in Excel",
    
   ];

   const inclusions8 = [

       'E-way bill facility (If required)',
      "Documents sharing",
     
      "Password sharing",
      "Round the clock support",
      "Time to time updates & notifications",
      'Time to time advice and support',
     
    
   ];
   const tenures9 = [
      {
         duration: "yearly",
         value: "4 Years",
         label: "1 Year",
         price: "₹12251.00",
         yearlyPrice: "₹32669.00",
         savings: "Save 50% + 25%",
      },
      {
         duration: "Monthly",
         value: "1 Year",
         label: "1 Month",
         price: "₹1551.00",
         yearlyPrice: "₹3102.00",
         savings: "Save 50%",
      },
      {
         duration: "Quarterly",
         value: "2 Years",
         label: "3 Month",
         price: "₹3851.00",
         yearlyPrice: "₹7702.00",
         savings: "Save 50%",
      },
      {
         duration: "Half-yearly",
         value: "3 Years",
         label: "6 Month",
         price: "₹6551.00",
         yearlyPrice: "₹15414.00",
         savings: "Save 50% + 15%",
      },
      {
         duration: "yearly",
         value: "5 Years",
         label: "2 Year",
         price: "₹24502.00",
         yearlyPrice: "₹65339.00",
         savings: "Save 50% + 25%",
      },
   ];
   const requirements9 = [
      "GSTR - 3B Excel file",
      "GSTR - 1 File",
      "Normal Excel file of Sales & Purchase"
   ];

   const inclusions9 = [
      "E-way bill facility",


      "Documents sharing facility",
      "Download deliverables any time",
      "Password sharing",
      "Round the clock support",
      "Time to time updates & notifications"
   ];

   const tenures10 = [
      {
         duration: "yearly",
         value: "4 Years",
         label: "1 Year",
         price: "₹16251.00",
         yearlyPrice: "₹43336.00",
         savings: "Save 50% + 25%",
      },
      {
         duration: "Monthly",
         value: "1 Year",
         label: "1 Month",
         price: "₹2051.00",
         yearlyPrice: "₹4102.00",
         savings: "Save 50%",
      },
      {
         duration: "Quarterly",
         value: "2 Years",
         label: "3 Month",
         price: "₹5351.00",
         yearlyPrice: "₹10702.00",
         savings: "Save 50%",
      },
      {
         duration: "Half-yearly",
         value: "3 Years",
         label: "6 Month",
         price: "₹9251.00",
         yearlyPrice: "₹21767.00",
         savings: "Save 50% + 15%",
      },
      {
         duration: "yearly",
         value: "5 Years",
         label: "2 Year",
         price: "₹32502.00",
         yearlyPrice: "₹86672.00",
         savings: "Save 50% + 25%",
      },
   ];

   const requirements10 = [
      "GSTR - 3B Excel file",
      "GSTR - 1 File",
      "Normal Excel file of Sales & Purchase"
   ];
   const inclusions10 = [


      "Documents sharing facility",
      "Download deliverables any time",
      "Password sharing",
      "Round the clock support",
      "Time to time updates & notifications"
   ];

   const tenures11 = [
      {
         value: "4 Years",
         label: "1 Year",
         price: "₹18251.00",
         duration: "yearly",
         yearlyPrice: "₹48669.00",
         savings: "Save 50% + 25%",
      },
      {
         value: "1 Year",
         label: "1 month",
         price: "₹2251.00",
         duration: "monthly",
         yearlyPrice: "₹4502.00",
         savings: "Save 50%",
      },
      {
         value: "2 Years",
         label: "3 month",
         price: "₹5851.00",
         duration: "Quarterly",
         yearlyPrice: "₹11702.00",
         savings: "Save 50%",
      },
      {
         value: "3 Years",
         label: "6 month",
         price: "₹10251.00",
         duration: "Half-yearly",
         yearlyPrice: "₹24120.00",
         savings: "Save 50% + 15%",
      },
      {
         value: "5 Years",
         label: "2 Year",
         price: "₹36502.00",
         duration: "yearly",
         yearlyPrice: "₹97339.00",
         savings: "Save 50% + 25%",
      },
   ];

   const requirements11 = [
      "GSTR - 3B Excel file",
      "GSTR - 1 File",
      "Normal Excel file of Sales & Purchase"
   ];

   const inclusions11 = [
      "E-way bill facility",


      "Documents sharing facility",
      "Download deliverables any time",
      "Password sharing",
      "Round the clock support",
      "Time to time updates & notifications"
   ];
   const tenures12 = [
      {
         value: "4 Years",
         label: "1 Year",
         price: "₹20251.00",
         duration: "yearly",
         yearlyPrice: "₹54003.00",
         savings: "Save 50% + 25%",
      },
      {
         value: "1 Year",
         label: "1 Month",
         price: "₹2351.00",
         duration: "monthly",
         yearlyPrice: "₹4702.00",
         savings: "Save 50%",
      },
      {
         value: "2 Years",
         label: "3 Months",
         price: "₹6551.00",
         duration: "Quarterly",
         yearlyPrice: "₹13002.00",
         savings: "Save 50%",
      },
      {
         value: "3 Years",
         label: "6 Months",
         price: "₹11251.00",
         duration: "Half-yearly",
         yearlyPrice: "₹26473.00",
         savings: "Save 50% + 15%",
      },
      {
         value: "5 Years",
         label: "2 Years",
         price: "₹40502.00",
         duration: "yearly",
         yearlyPrice: "₹108005.00",
         savings: "Save 50% + 25%",
      },
   ];

   const requirements12 = [
      'GSTR - 3B Excel file',
      'GSTR - 1 File',
      'Normal Excel file of Sales & Purchase'
   ];

   const inclusions12 = [
      'Dashboard for managing service',
      'Mobile application support',
      'Documents sharing facility',
      'Download deliverables any time',
      'Password sharing',
      'Round the clock support',
      'Time to time updates & notifications'
   ];

   const tenures13 = [
      { label: "1 Year", price: "22251.00", duration: "yearly", yearlyPrice: "59336.00", savings: "Save 50% + 25%" },
      { label: "1 month", price: "2551.00", duration: "month", yearlyPrice: "5102.00", savings: "Save 50%" },
      { label: "3 month", price: "7251.00", duration: "Quarterly", yearlyPrice: "14502.00", savings: "Save 50%" },
      { label: "6 month", price: "12251.00", duration: "Half-yearly", yearlyPrice: "20026.00", savings: "Save 50% + 15%" },
      { label: "2 Year", price: "44502.00", duration: "yearly", yearlyPrice: "110672.00", savings: "Save 50% + 25%" }
   ];

   const requirements13 = [
      'GSTR - 3B Excel file',
      'GSTR - 1 File',
      'Normal Excel file of Sales & Purchase',
   ];

   const inclusions13 = [
      'E-way bill facility',
      'Dashboard for managing service',
      'Mobile application support',
      'Documents sharing facility',
      'Download deliverables any time',
      'Password sharing',
      'Round the clock support',
      'Time to time updates & notifications',
   ];





   const [receivedData, setReceivedData] = useState(null);

   const handleDataFromChild = (data) => {
      console.log("Data received from child:", data);
      setReceivedData(data);
   };


   const [newData, setNewData] = useState({ user_name: '', user_designation: '', user_email: '', user_contact: '', user_related_query: '' })

   const [errors, setErrors] = useState({});
   const { services, loading, error } = useContext(ServicesContext);  
   if (loading) {
      return <div>Loading...</div>;  // Show loading state while fetching data
  }

  if (error) {
       return <div>{error}</div> // Show error state if there was an issue fetching data
  }
   const service = services.find(s => s.service_id === 15);

   const validateForm = () => {
      const newErrors = {};

      if (!newData.user_name.trim()) {
         newErrors.user_name = 'Name is required.';
      } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
      }
      if (!newData.user_designation.trim()) {
         newErrors.user_designation = 'Name is required.';
      } else if (!/^[a-zA-Z\s]+$/.test(newData.user_designation)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
      }

      if (!newData.user_email.trim()) {
         newErrors.user_email = 'Email is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_email)) {
         newErrors.user_email = 'Enter a valid email address.';
      }

      if (newData.user_contact && !/^\d{10}$/.test(newData.user_contact)) {
         newErrors.user_contact = 'Enter a valid 10-digit contact number.';
      }

      if (!newData.user_related_query) {
         newErrors.user_related_query = 'This field required.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // No errors
   };




   const formPutPartenshipdeed = async (e) => {
      e.preventDefault();
      if (validateForm()) {
         try {
            console.log("Form Data to Submit:", newData); // Debugging
            const data = await PartenerSheepDeedService.gstReturnForm(newData);
            setNewData({
               user_name: '',
               user_email: '',
               user_contact: '',
               user_related_query: '',
               user_designation: '',
            });
         }
         catch (error) {
            console.log(error);
         }
      }


   };

   return (
      <div>

         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <h1 className="sk-text-color">GST Return Filing</h1>
                        <p className="pdrl-text">Start with Only <span className="text-color"> Rs.{service?.price}/- </span><span>(Final Price, No Hidden Costs)</span>  </p>
                        <p className="pd-text">Dm2Legal’s expert team specializes in GST return filing, offering tailored plans based on your business type, trade, tax deductions, and transaction volume. We ensure timely filings, helping you avoid penalties while staying compliant. Let our professionals handle your GST returns with precision and reliability.</p>
                        <div className="btn-group">
                           <Link to="/contactus" className="theme-btn-3 btn-color ">
                              Schedule A Call <span><i className="fa-solid fa-arrow-right"></i></span>
                           </Link>

                        </div>
                        <div className="space30"></div>
                        <a href="gst-registration.html"><p className="pd-text">Know more about GST & Registration</p></a>
                        <div className="banner">
                           <img src="assets/icons/banner.svg" alt="" srcset="" />
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="gst-hero">
                        <img src="assets/img/images/choose-legal251.jpg" alt="" />
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space80"></div>


         <div className="home4-counters bg-white">
            <div className="container">




               <div className="space40"></div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">

                        <h2 className="aos-init aos-animate text-center">Pricing Plans</h2>
                     </div>
                     <p className="pd-text text-center">Please select Turnover:</p>
                     <div className="price-heading">
                        <select id="dropdown" onChange={handleChange}>

                           <option value="option1">NIL (Bills Cover 3)</option>
                           <option value="option2">Rs.1 to Upto 15 Lac (Bills Cover 15) </option>
                           <option value="option3">15 Lac to 60 Lac (Bills Cover 30) </option>

                           <option value="option4">60 Lac to 1.50 Crore (Bills Cover 60)</option>
                           <option value="option6">More than 1.50 Crore</option>


                        </select>
                     </div>
                     &nbsp;
                     {selectedOption === "option1" && (<div className="box-container" id="option1-boxes">
                        <div className="container ">
                           <div className="row  box-center">
                              <div className="col-md-3 col-sm-6">

                                 <PricingPlan2
                                    title="Monthly"
                                    tenures={tenures1}
                                    duration='Monthly'
                                    price="250"
                                    requirements={requirements1}
                                    inclusions={inclusions1}
                                    onSubmit={handleDataFromChild}
                                 />


                              </div>



                              <div className="col-md-3 col-sm-6">
                                 <PricingPlan2
                                    title="Quarterly"
                                    tenures={tenures}
                                    duration='Quarterly'
                                    price="600"
                                    requirements={requirements}
                                    inclusions={inclusions}
                                    onSubmit={handleDataFromChild}
                                 />
                              </div>


                              <div className="col-md-3 col-sm-6">

                                 <PricingPlan2
                                    title="Yearly"
                                    tenures={tenures3}
                                    duration='Yearly'
                                    price="2000"
                                    requirements={requirements3}
                                    inclusions={inclusions3}
                                    onSubmit={handleDataFromChild}
                                 />
                              </div>

                           </div>
                        </div>
                     </div>)}
                     {selectedOption === "option2" && (<div className="box-container" id="option1-boxes">
                        <div className="container ">
                           <div className="row  box-center">
                              <div className="col-md-3 col-sm-6">

                                 <PricingPlan2
                                    title="Monthly"
                                    tenures={tenures1}
                                    duration='Monthly'
                                    price="400"
                                    requirements={requirements1}
                                    inclusions={inclusions1}
                                    onSubmit={handleDataFromChild}
                                 />


                              </div>



                              <div className="col-md-3 col-sm-6">
                                 <PricingPlan2
                                    title="Quarterly"
                                    tenures={tenures}
                                    price="1000"
                                    duration='Quarterly'
                                    requirements={requirements}
                                    inclusions={inclusions}
                                    onSubmit={handleDataFromChild}
                                 />
                              </div>


                              <div className="col-md-3 col-sm-6">

                                 <PricingPlan2
                                    title="Yearly"
                                    duration='Yearly'
                                    tenures={tenures3}
                                    price="3600"
                                    requirements={requirements3}
                                    inclusions={inclusions3}
                                    onSubmit={handleDataFromChild}
                                 />
                              </div>

                           </div>
                        </div>
                     </div>)}

                     {selectedOption === "option3" && (<div className="box-container" id="option2-boxes">
                        <div className="containerr">
                           <div className="row  box-center">
                              <div className="col-md-3 col-sm-6">

                                 <PricingPlan2
                                    title="Monthly"
                                    duration='Monthly'
                                    tenures={tenures4}
                                    price="600"
                                    requirements={requirements4}
                                    inclusions={inclusions4}
                                    onSubmit={handleDataFromChild}
                                 />
                              </div>

                              <div className="col-md-3 col-sm-6">

                                 <PricingPlan2
                                    title="Quarterly"
                                    tenures={tenures5}
                                    price="1200"
                                    duration='Quarterly'
                                    requirements={requirements5}
                                    inclusions={inclusions5}
                                    onSubmit={handleDataFromChild}
                                 />
                              </div>




                              <div className="col-md-3 col-sm-6">

                                 <PricingPlan2
                                    title="Yearly"
                                    tenures={tenures7}
                                    price="4000"
                                    duration='Yearly'
                                    requirements={requirements7}
                                    inclusions={inclusions7}
                                    onSubmit={handleDataFromChild}
                                 />
                              </div>

                           </div>
                        </div>
                     </div>)}

                     {selectedOption === "option4" && (<div className="box-container" id="option3-boxes">
                        <div className="container">
                           <div className="row box-center">


                              <div className="col-md-3 col-sm-6">

                                 <PricingPlan2
                                    title="Monthly"
                                    duration='Monthly'
                                    tenures={tenures8}
                                    price="750"
                                    requirements={requirements8}
                                    inclusions={inclusions8}
                                    onSubmit={handleDataFromChild}
                                 />
                              </div>


                              <div className="col-md-3 col-sm-6">

                                 <PricingPlan2
                                    title="Quarterly"
                                    duration='Quarterly'
                                    tenures={tenures8}
                                    price="1800"
                                    requirements={requirements8}
                                    inclusions={inclusions8}
                                    onSubmit={handleDataFromChild}
                                 />
                              </div>

                              <div className="col-md-3 col-sm-6">

                                 <PricingPlan2
                                    title="Yearly"
                                    tenures={tenures8}
                                    price="6000"
                                    duration='Yearly'
                                    requirements={requirements8}
                                    inclusions={inclusions8}
                                    onSubmit={handleDataFromChild}
                                 />
                              </div>

                           </div>
                        </div>
                     </div>)}





                     {selectedOption === "option6" && (<div className="box-container" id="option6-boxes">
                        <div className="container">
                           <div className="row box-center">





                              <div className="col-md-4 col-sm-6">
                                 <div className="pricing-plan">

                                    <div className="formContainer ">
                                       <form>
                                          <div className="form-group">
                                             <input type="text" className="form-control" placeholder="Contact Person Name"
                                                required value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                             {errors.user_name && <p className="error">{errors.user_name}</p>}
                                          </div>
                                          <div className="form-group">
                                             <input type="text" className="form-control" placeholder="Contact Person Designation" required value={newData.user_designation} onChange={(e) => setNewData({ ...newData, user_designation: e.target.value })} />
                                             {errors.user_designation && <p className="error">{errors.user_designation}</p>}
                                          </div>
                                          <div className="form-group">
                                             <input type="email" className="form-control" placeholder="Email" required value={newData.user_email} onChange={(e) => setNewData({ ...newData, user_email: e.target.value })} />
                                             {errors.user_email && <p className="error">{errors.user_email}</p>}
                                          </div>
                                          <div className="form-group">
                                             <input type="tel" className="form-control" placeholder="Contact No." required value={newData.user_contact} onChange={(e) => setNewData({ ...newData, user_contact: e.target.value })} />
                                             {errors.user_contact && <p className="error">{errors.user_contact}</p>}
                                          </div>
                                          <div className="form-group">
                                             <input type="text" className="form-control"
                                                placeholder="Tentative Parties Quarterly" required onChange={(e) => setNewData({ ...newData, user_related_query: e.target.value })} value={newData.user_related_query} />
                                             {errors.user_related_query && <p className="error">{errors.user_related_query}</p>}
                                          </div>
                                          <button type="submit" className="getStartedBtn btn btn-light" onClick={formPutPartenshipdeed}>Submit</button>
                                       </form>
                                    </div>
                                 </div>
                              </div>



                           </div>
                        </div>
                     </div>)}

                  </div>
               </div>




            </div>
         </div>

         <div className="container">
            <div className="space40"></div>

            <div className="row">
               <div className="col-lg-12">
                  <div className="hadding7">
                     <h2 className="text-center">How to apply</h2>
                     <div className="space20"></div>
                     <img src="assets/img/images/legal251-how-to-apply.png" alt="" />
                  </div>
               </div>
            </div>
            <div className="space80"></div>

         </div>

         <div className="service-binifits9 sp0" id="service2">
            <div className="space50"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Types of forms</h2>
                     </div>
                  </div>
                  <div className="space40"></div>
                  <div className="tabs">
                     <div className="tab-row">
                        <div
                           className={`tab ${activeTab === 1 ? 'active-tab' : ''}`}
                           onClick={() => showContent(1)}
                        >
                           GSTR - 1
                        </div>
                        <div
                           className={`tab ${activeTab === 2 ? 'active-tab' : ''}`}
                           onClick={() => showContent(2)}
                        >
                           GSTR - 2
                        </div>
                        <div
                           className={`tab ${activeTab === 3 ? 'active-tab' : ''}`}
                           onClick={() => showContent(3)}
                        >
                           GSTR - 4
                        </div>
                        <div
                           className={`tab ${activeTab === 4 ? 'active-tab' : ''}`}
                           onClick={() => showContent(4)}
                        >
                           GSTR - 5A
                        </div>
                        <div
                           className={`tab ${activeTab === 5 ? 'active-tab' : ''}`}
                           onClick={() => showContent(5)}
                        >
                           GSTR - 6
                        </div>
                        <div
                           className={`tab ${activeTab === 6 ? 'active-tab' : ''}`}
                           onClick={() => showContent(6)}
                        >
                           GSTR - 7A
                        </div>
                     </div>
                     <div className="tab-row">
                        <div className={`tab ${activeTab === 7 ? 'active-tab' : ''}`} onClick={() => showContent(7)}>GSTR-9</div>

                        <div
                           className={`tab ${activeTab === 8 ? 'active-tab' : ''}`}
                           onClick={() => showContent(8)}
                        >
                           GSTR-9C
                        </div>
                        <div
                           className={`tab ${activeTab === 9 ? 'active-tab' : ''}`}
                           onClick={() => showContent(9)}
                        >
                           GSTR-2A
                        </div>
                        <div
                           className={`tab ${activeTab === 10 ? 'active-tab' : ''}`}
                           onClick={() => showContent(10)}
                        >
                           GSTR-3B
                        </div>
                        <div
                           className={`tab ${activeTab === 11 ? 'active-tab' : ''}`}
                           onClick={() => showContent(11)}
                        >
                           GSTR-5
                        </div>


                     </div>
                     <div className="tab-row">
                        <div
                           className={`tab ${activeTab === 12 ? 'active-tab' : ''}`}
                           onClick={() => showContent(12)}
                        >
                           GSTR-6A
                        </div>
                        <div
                           className={`tab ${activeTab === 13 ? 'active-tab' : ''}`}
                           onClick={() => showContent(13)}
                        >
                           GSTR-7
                        </div>
                        <div
                           className={`tab ${activeTab === 14 ? 'active-tab' : ''}`}
                           onClick={() => showContent(14)}
                        >
                           GSTR-8
                        </div>
                        <div
                           className={`tab ${activeTab === 15 ? 'active-tab' : ''}`}
                           onClick={() => showContent(15)}
                        >
                           GSTR-9A
                        </div>
                        <div
                           className={`tab ${activeTab === 16 ? 'active-tab' : ''}`}
                           onClick={() => showContent(16)}
                        >
                           GSTR-10
                        </div>
                        <div
                           className={`tab ${activeTab === 17 ? 'active-tab' : ''}`}
                           onClick={() => showContent(17)}
                        >
                           All other Forms
                        </div>

                     </div>
                  </div>
                  <div className="space30"></div>
                  <div className="contents">
                     {activeTab === 1 && (
                        <div className="content" id="content1">
                           <h2>GSTR-1</h2>
                           <p>
                              GSTR-1 is a monthly return form that businesses file to report
                              details of all outward supplies of goods and services. Every
                              GST-registered entity must file GSTR-1, except for Input
                              Service Distributors and Composition Taxpayers. It is required
                              even if there has been no business activity during the month.
                              The due date for filing GSTR-1 is the 10th of each month.
                           </p>
                           <p>
                              GSTR-1 serves as the basis for all other return submissions for
                              the month.
                           </p>
                        </div>
                     )}
                     {activeTab === 2 && (
                        <div className="content" id="content2">
                           <h2>GSTR-2</h2>
                           <p>
                              GSTR-2 is the return used to provide details of all inward
                              supplies of goods and services. While this form could be
                              edited, the government has currently suspended its filing.
                           </p>
                        </div>
                     )}
                     {activeTab === 3 && (
                        <div className="content" id="content3">
                           <h2>GSTR-4</h2>
                           <p>
                              GSTR-4 is an annual return filed by all taxpayers under the GST
                              composition scheme. Businesses must provide a summary of
                              outward supplies and the taxes paid on them, along with
                              details of any import of services and supplies subject to
                              reverse charge.
                           </p>
                           <p>
                              The due date for filing this form is the 30th of the month
                              following the end of the financial year.
                           </p>
                        </div>
                     )}
                     {activeTab === 4 && (
                        <div className="content" id="content4">
                           <h2>GSTR-5A</h2>
                           <p>
                              Form GSTR-5A is filed by service providers of Online
                              Information and Database Access or Retrieval (OIDAR) services.
                              This form is used to report services provided to unregistered
                              entities or individuals in India by a provider located outside
                              India. It is a monthly return and must be filed by the 20th of
                              each month.
                           </p>
                        </div>
                     )}
                     {activeTab === 5 && (
                        <div className="content" id="content5">
                           <h2>GSTR-6</h2>
                           <p>
                              The Input Service Distributor generates and files GSTR-6 only
                              after accepting and verifying all details provided in GSTR-6A.
                              This filing must be completed by the 13th of each month.
                           </p>
                        </div>
                     )}
                     {activeTab === 6 && (
                        <div className="content" id="content6">
                           <h2>GSTR-7A</h2>
                           <p>
                              GSTR-7A, also known as the TDS certificate, is generated as
                              soon as the tax deductor files GSTR in Form GSTR-7. It is used
                              by the assessee for record-keeping purposes.
                           </p>
                        </div>
                     )}
                     {activeTab === 7 && (
                        <div className="content" id="content6">
                           <h2>GSTR-9</h2>
                           <p>The GSTR-9 must be filed by all eligible taxpayers by the 31st of December following
                              the financial year. It primarily summarizes information from the twelve GSTR-3 returns filed throughout the year.</p>
                        </div>
                     )}
                     {activeTab === 8 && (
                        <div className="content" id="content6">
                           <h2>GSTR-9C</h2>
                           <p>The GSTR-9C reconciliation statement must be filed by registered taxpayers with total annual revenue
                              exceeding ₹5 crore for the applicable financial year. Taxpayers are required to complete and self-certify GSTR-9C on the GST portal. This form is mandatory for taxpayers whose annual accounts are subject to audit under GST regulations.</p>
                        </div>
                     )}
                     {activeTab === 9 && (
                        <div className="content" id="content6">
                           <h2>GSTR-2A</h2>
                           <p>
                              GSTR-2A is a return that provides details of all inward supplies of goods and services, reflecting purchases made from registered suppliers. This form is
                              auto-populated with data from the GSTR-1 filed by the suppliers and must be reviewed by the 15th of each month. It is a read-only return and cannot be edited.
                           </p>
                        </div>
                     )}
                     {activeTab === 10 && (
                        <div className="content" id="content6">
                           <h2>GSTR-3B</h2>
                           <p>
                              GSTR-3B is a summarized monthly return that includes details of both inward and outward supplies,
                              input tax credits, and all GST liabilities. It is a self-declaration form filed by all taxpayers for each tax period.
                           </p>
                        </div>
                     )}
                     {activeTab === 11 && (
                        <div className="content" id="content6">
                           <h2>GSTR-5</h2>
                           <p>
                              This form is filed by all non-resident taxpayers registered in India who conduct business operations within the country. In the GSTR-5 return,
                              businesses must provide details of all inward and outward supplies, as well as their tax liabilities. It is a monthly return that must be filed by the 20th of each month.
                           </p>
                        </div>
                     )}
                     {activeTab === 12 && (
                        <div className="content" id="content6">
                           <h2>GSTR-6A</h2>
                           <p>
                              The GSTR-6A form is a system-generated "draft" statement of inward supplies for a recipient taxpayer. It is a read-only form.
                           </p>
                        </div>
                     )}
                     {activeTab === 13 && (
                        <div className="content" id="content13">
                           <h2>GSTR-7</h2>
                           <p className="pd-text">GSTR-7 is filed by entities that deduct tax while making payments to suppliers for purchases, i.e., inward supplies received.</p>
                           <p className="pd-text">The GSTR-7 form includes details of Tax Deducted at Source (TDS) under GST, the tax liability, and TDS refunds.</p>
                           <p className="pd-text">GSTR-7 must be filed by the 10th of the following month.</p>
                        </div>
                     )}
                     {activeTab === 14 && (
                        <div className="content" id="content14">
                           <h2>GSTR-8</h2>
                           <p className="pd-text">The GSTR-8 form is filed by e-commerce businesses that collect Tax Collected at Source (TCS) to report details of supplies made through the e-commerce platform.</p>
                           <p className="pd-text">It must be filed by the 10th of each month.</p>
                        </div>
                     )}
                     {activeTab === 15 && (
                        <div className="content" id="content15">
                           <h2>GSTR-9A</h2>
                           <p className="pd-text">GSTR-9A is filed by entities that have opted for the composition scheme at any point during the financial year. The form provides details of inward and outward supplies, taxes paid, demand created, refunds, and input tax credits availed or reversed.</p>
                        </div>
                     )}
                     {activeTab === 16 && (
                        <div className="content" id="content16">
                           <h2>GSTR-10</h2>
                           <p className="pd-text">A taxable person whose GST registration is canceled or surrendered must file a return in Form GSTR-10, also known as the Final Return. This form provides a statement of the stocks held by the taxpayer on the day immediately preceding the effective date of cancellation. The return must be filed within three months from the date of cancellation or the date of the cancellation order, whichever is later.</p>
                        </div>

                     )}
                     {activeTab === 17 && (
                        <div className="content" id="content17">
                           <h2>All other Forms</h2>
                           <p className="pd-text">This includes Registration Forms, Composition Scheme Forms, Forms for Enrollment under Section 35, GSTR-11 and all GST Return Forms, Input Tax Credit Forms, Electronic Ledger/Payment Forms, GST Audit Forms, Advance Ruling Forms, Forms for the Appellate Authority of Advance Ruling, Transitional Credit Forms, E-Way Bill Forms, and Inspection Forms. Dm2Legal will handle all of these as per their applicability.</p>
                        </div>
                     )}
                  </div>
                  <div className="space30"></div>
               </div>
            </div>
         </div>

         {/* <GSTForms /> */}
         <div className="space40"></div>


         <div className="service-binifits9 sp0 bg-white"  >

            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Benefits of Using Dm2Legal for GST Return Filing </h2>
                        <div className="service-binifits-boxs">
                           <div className="row">
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Time Effective Process</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Accuracy in Filing</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Team of Experts</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Assured Complete Compliance</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Budget Friendly</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Simplifying GST Return Filing</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          No Hidden Charges</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          Support for Multiple GST Categories</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs bg-box">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>
                                          24x7 Customer Support</p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="space40"></div>

               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Importance of Timely GST Return Filing  </h2>
                        <div className="space20"></div>
                        <p className="pd-text">GST return filing is essential for compliance, helping businesses avoid penalties, claim input tax credits, and maintain creditworthiness. Timely filings reduce audit risks and support seamless business growth and expansion.</p>
                     </div>
                  </div>
                  <div className="col-lg-7">
                     <div className="contact6-list doc-list">
                        <ul>
                           <div className="space20"></div>
                           <p className="pd-text">Following are some of the importance of filing GST Returns on time:-</p>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Compliance with Legal Requirements</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Input Tax Credit Availability</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Avoidance of Late Fees and Penalties</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Maintaining a Good Business Reputation</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Avoidance of Business Disruptions</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Facilitates Government Revenue Collection</li>
                        </ul>
                     </div>
                  </div>
                  <div className="col-lg-5">
                     <div className="contact6-list doc-list">
                        <img src="assets/img/images/Importance-of-Timely-GST-Return-Filing.png" alt="" />
                     </div>
                  </div>

               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Common Mistakes to Avoid in GST Return Filing </h2>
                     </div>
                  </div>
                  <div className="col-lg-7">
                     <div className="contact6-list doc-list">
                        <ul>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Lack of documentation</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Inaccurate invoice details</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Any difference in GSTR-2A and GSTR-3B</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Avoid Incomplete or inaccurate data entry</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Missing the GST return due dates</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Not validating GSTIN of suppliers</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Incorrect classNameification of tax</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Non-Compliance with GST Rules and Updates</li>
                        </ul>
                     </div>
                  </div>
                  <div className="col-lg-5">
                     <div className="contact6-list doc-list">
                        <img src="assets/img/images/Common-Mistakes-to-Avoid-in-GST-Return-Filing.png" alt="" />
                     </div>
                  </div>
               </div>
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">GST Return Filing for Small Businesses</h2>
                     </div>
                  </div>
                  <div className="space30"></div>
                  <div className="col-lg-7">
                     <div className="space40"></div>
                     <p className="pd-text">GST return filing can be challenging for small businesses, but with proper record-keeping, a clear understanding of the process, and the right accounting tools, it becomes manageable. Timely and accurate filing ensures compliance, prevents penalties, and promotes a transparent and efficient tax system.</p>
                  </div>
                  <div className="col-lg-5">
                     <div className="contact6-list doc-list">
                        <img src="assets/img/images/GST-Return-Filing-for-Small-Businesses.png" alt="" />
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="space40"></div>

         <div className="service-binifits9 " id="service2">
            <div className="container work8">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Documents Required for GST Return Filing</h2>
                        <div className="space10"></div>
                        <p className="pd-text text-center"> You will require all the following documents for GST return filing:-</p>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="contact6-list doc-list">
                        <img src="assets/img/images/Documents-Required-for-GST-Return-Filing.png" alt="" />
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="single-price">
                        <div className="price-heading">
                           <h3 className="text-center">Documents List</h3>
                        </div>
                        <div className="price-body">
                           <ul>
                              <h3>One time:</h3>
                              <ul>
                                 <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; GST Number</li>
                                 <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; GST Registration Certificate</li>
                              </ul>
                              <div className="space30"></div>
                              <h3>Monthly:</h3>
                              <p>Starter and Basic plans::</p>
                              <ul>
                                 <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; GSTR - 3B (Soft copy)</li>
                                 <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; GSTR - 1 (Soft copy)</li>
                                 <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Normal Excel file of Sales & Purchase</li>
                              </ul>
                              <div className="space40"></div>
                              <p>Pro and Premium plans:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Sales & Purchase Invoices</li>
                                 <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; GSTR - 3B (Soft copy)</li>
                                 <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp; GSTR - 1 (Soft copy)</li>
                                 <li><span className="pricing-icon"><img src="assets/image/doc-01.svg" alt="" /></span>&nbsp;Normal Excel file of Sales & Purchase</li>
                              </ul>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="space30"></div>
               </div>
            </div>
         </div>




         <div className="bg-white">

            <div className="container ">

               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FAQs on GST Return Filing </h2>
                              <div className="space30"></div>


                              <div id="general">


                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                       Q1: What does GST return filing involve?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">GST return filing refers to the process of submitting periodic details of sales, purchases, taxes, and other relevant transactions to the tax authorities. It is a legal requirement for businesses registered under GST and helps in determining the tax liability.</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2: How can documents be submitted for GST purposes?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">You can easily upload all your documents using our web dashboard or app. You can review them later and share them with anyone as needed.</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3: Can a person without a GST number collect GST ?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">No, a person without GST registration cannot collect GST. Only businesses or individuals who are registered under GST are authorized to collect GST from their customers and remit it to the government.</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4: What is the maximum cash transaction limit under GST?
                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">Under GST, the cash transaction limit for businesses is Rs.10,000 per day. Payments exceeding this amount must be made through banking channels.</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5: What is the GST Composition Scheme?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">The GST Composition Scheme allows small businesses with annual turnover up to Rs.1.5 crore (Rs.75 lakh for some states) to pay tax at a lower rate. It simplifies tax compliance by allowing businesses to file quarterly returns instead of monthly ones.</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6: What happens if I fail to pay my GST return?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Failure to pay GST returns on time can lead to penalties, interest charges, and legal action. The government may impose a fine and charge interest for delayed payments. Repeated non-payment can also result in suspension of GST registration.
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                       Q7: Is GST applicable to all businesses?
                                       <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">No, GST is not applicable to all businesses. It applies to businesses with a turnover above a certain threshold limit. Small businesses with turnover below this limit may be exempt or eligible for the Composition Schem</p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8: What taxes does GST replace?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">GST replaces various indirect taxes such as:</p>
                                       <ul>
                                          <li>Value Added Tax (VAT)</li>
                                          <li>Central Excise Duty</li>
                                          <li>Countervailing Duty</li>
                                          <li>Central Excise Duty</li>
                                          <li>Value Added Tax (VAT)</li>
                                          <li>Sales Tax</li>
                                          <li>Octroi</li>
                                          <li>Customs Duty (on imports)</li>
                                          <li>Entry Tax</li>

                                       </ul>
                                       It simplifies the tax structure by consolidating multiple taxes into one unified tax system.
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 9 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(9)}
                                    >
                                       Q9: Are separate forms required for IGST, SGST, and CGST?
                                       <span>
                                          {activeQuestion === 9 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 9 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          Yes, separate forms are required for each type of tax under GST:

                                          IGST (Integrated Goods and Services Tax): For inter-state transactions (between states).
                                          SGST (State Goods and Services Tax): For intra-state transactions (within the same state).
                                          CGST (Central Goods and Services Tax): Also for intra-state transactions, collected by the central government.
                                          These taxes are filed through different sections in GST returns, depending on the type of transaction.</p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 10 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(10)}
                                    >
                                       Q10: What are the consequences of not filing a GST return within the due date?
                                       <span>
                                          {activeQuestion === 10 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 10 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          If the return is filed late, a late fee of Rs.100 per day will be charged. The maximum late fee is Rs.5,000.
                                       </p>
                                    </div>
                                 </div>








                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

         </div>




         <Testimonial />





         <div className="sp2 last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12 ">
                     <div className="hadding7">

                        <h2 className="text-center">Why Choose Dm2Legal for GST Return Filing Online?</h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/reg.svg" alt="" /></span><a href="single-service-1.html" >Convenient Filing</a></h4>
                           <p>Dm2Legal offers a convenient platform that saves time and effort. Our user-friendly process for GST return filing, supported by our expert team, simplifies and streamlines the entire procedure.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/online.svg" alt="" /></span><a href="single-service-1.html" >Best Online Platform</a></h4>
                           <p>Dm2Legal is a user-friendly, secure, and efficient online platform for filing GST returns. Its intuitive design makes it easy to navigate the GST return filing process with ease. </p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/customer.svg" alt="" /></span><a href="single-service-1.html" >Best Customer Support</a></h4>
                           <p>Dm2Legal offers responsive and helpful customer support, making it easier to resolve any issues or answer questions you may have during the GST filing process. This ensures a smoother and more efficient experience.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>Dm2Legal boasts an experienced team that brings expertise, awareness, and accuracy to your GST return filings. Our team's in-depth knowledge of GST laws and regulations is a key factor in ensuring effective and efficient GST return filing.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >On-time Service</a></h4>
                           <p>We understand that timeliness is essential for GST return filing compliance. Filing your returns on time helps avoid penalties and ensures your business remains in good standing with authorities and regulations.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/friendly.svg" alt="" /></span><a href="single-service-1.html" >Pocket-friendly Services</a></h4>
                           <p>At Dm2Legal, we specialize in providing cost-effective solutions. Our competitive pricing and value-for-money packages make us a great choice for your GST return filing needs.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="space40"></div>


         <WhatsAppScrollButton />
         <Footer />
         <CircularScrollProgress />


      </div>

   );
}
export default GSTreturnfiling;





